import React from 'react';
import PropTypes from 'prop-types';
const { string, objectOf } = PropTypes;
import './temp-breadcrumbs.scss';

const powerToolsTitle = 'Power Tools';
const powerToolsUrl = '/b/Tools-Power-Tools/N-5yc1vZc298';
const chemicalsTitle = 'Chemicals';
const chemicalsUrl = '/b/Outdoors-Garden-Center-Pest-Control/N-5yc1vZbx4w';
const applianceTitle = 'Appliances';
const applianceUrl = '/b/Appliances/N-5yc1vZbv1w';
const kitchenPackageTitle = 'Kitchen Packages';
const kitchenPackageUrl = '/c/kitchen_appliance_packages';

const pilotIds = {
  powerTools: [
    'package_1',
    'package_2',
    'package_3',
    'package_4',
    'package_5',
    'package_6',
    'package_7',
    'package_8',
    'package_9',
    'package_10',
    'package_11',
    'package_12',
    'package_13',
    'package_14',
    'package_15'
  ],
  chemicals: [
    'package_16',
    'package_17',
    'package_39366070',
    'package_864301143',
    'package_N1359453119',
    'package_475182706'
  ]
}

const breadcrumbTemplate = (l1, l1url, packageName) => {
  return {
    levelOne: { title: l1, url: l1url },
    levelTwo: { title: packageName, url: '' },
  }
}

const getBreadcrumbTemplate = (packageId, packageName) => {
  if (pilotIds?.powerTools?.indexOf(packageId) !== -1) {
    return breadcrumbTemplate(powerToolsTitle, powerToolsUrl, packageName);
  }
  if (pilotIds?.chemicals?.indexOf(packageId) !== -1) {
    return breadcrumbTemplate(chemicalsTitle, chemicalsUrl, packageName);
  }
  return {
    levelOne: { title: applianceTitle, url: applianceUrl },
    levelTwo: { title: kitchenPackageTitle, url: kitchenPackageUrl },
    levelThree: { title: packageName, url: '' },
  }
};

export const getBreadCrumbLevels = ({ metadata, packageId }) => {
  const { name, brandName } = metadata;
  let packageName = name;
  if (!name?.includes(brandName)) {
    packageName = `${brandName} ${name}`;
  }
  return getBreadcrumbTemplate(packageId, packageName);
}

export const TempBreadcrumbs = ({ metadata, packageId }) => {
  if (!metadata || !metadata.name) return null;

  let { levelOne, levelTwo, levelThree } = getBreadCrumbLevels({ metadata, packageId });
  return (
    <div className="breadcrumbs__nowrap">
      <div className="breadcrumb__item">
        <a href="/">Home</a>
      </div>
      <div className="breadcrumb__item">
        <a href={levelOne.url}>{levelOne.title}</a>
      </div>
      <div className="breadcrumb__item">
        <a href={levelTwo.url}>{levelTwo.title}</a>
      </div>
      { levelThree
        && (
          <div className="breadcrumb__item">
            <a href={levelThree.url}>{levelThree.title}</a>
          </div>
        )}
    </div>
  )
}

TempBreadcrumbs.propTypes = {
  metadata: objectOf(
    PropTypes.oneOfType([string, PropTypes.object])
  ),
  packageId: string
};

TempBreadcrumbs.defaultProps = {
  metadata: null,
  packageId: null
};